import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-one-platform-school-erp-lms-system-virsa',
  templateUrl: './one-platform-school-erp-lms-system-virsa.component.html',
  styleUrls: ['./one-platform-school-erp-lms-system-virsa.component.scss']
})
export class OnePlatformSchoolErpLmsSystemVirsaComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('One Platform for Students, Teachers & Parents | Virsa LMS System');
    this.metaService.updateTag({ name: 'description', content: 'Discover how Virsa school ERP and LMS system connects students, teachers, parents, and management on one platform with AI-powered learning, tracking, and analytics.' });
    this.metaService.updateTag({ name: 'keywords', content: 'school ERP and LMS system, LMS for schools India, AI LMS for education, smart school management system, Virsa LMS, digital learning platform schools' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
